var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.wrapperClassList }, [
    _c(
      "div",
      { staticClass: "_flex _ai-c _gap-3" },
      [
        _c(
          "div",
          {
            staticClass: "_flex _ai-c _gap-1 _cur-p _grow-1",
            attrs: { "data-qa": "collapsible:trigger" },
            on: { click: _vm.toggleExpand },
          },
          [
            _vm._t(
              "trigger",
              function () {
                return [_c("base-icon", { attrs: { name: _vm.iconName } })]
              },
              { isExpanded: _vm.isExpandedComputed }
            ),
          ],
          2
        ),
        _vm._v(" "),
        _vm._t("header-content"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: _vm.contentClassList,
        attrs: { "data-qa": "collapsible:content" },
      },
      [_vm._t("content")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }